import { CSRF_TOKEN_ID } from '../constants/userManagementConstants';

const updateCSRFToken = () => {
  const csrfTokenMeta = document.querySelector(`meta[name='${CSRF_TOKEN_ID}']`);
  if (csrfTokenMeta) {
    sessionStorage.setItem(
      CSRF_TOKEN_ID,
      csrfTokenMeta.getAttribute('content'),
    );
  }
};
export default updateCSRFToken;
